module.exports = __webpack_public_path__ + "img/bolt.57fa955e.svg";